import Layout from "./components/Layout";

function App() {
  return (
    <>
      {/* <nav className="navbar">
        <NavBar />
      </nav> */}
      <div>
        <Layout />
      </div>
    </>
  );
}

export default App;
